<template>
  <v-toolbar flat class="white" height="70" width="100%" style="{padding-left:0px;}">
    <v-toolbar-title id="headerTitle">
      <a v-on:click="home" title="Maroondah Cycle Training Club" class="mt-1">
        <img id="headerLogo" :src="logo.src" class="mt-1" />
      </a>
    </v-toolbar-title>
    <v-spacer></v-spacer>
    <v-btn
      depressed
      class="red white--text mr-1"
      v-on:click="dashboard" v-if="isAdmin"
    >
      <span>Switch to Admin</span>
    </v-btn>
    <v-btn
      depressed
      class="info mr-1"
      v-on:click="account" v-if="user"
    >
      <span>My Account</span>
    </v-btn>
    <!-- <v-btn
      v-show="!user"
      depressed
      v-on:click="register"
    >
      <span>Register</span>
    </v-btn> -->
    <v-btn
      outline
      color="grey darken-2"

      v-on:click="home"
    >
      <span>Home</span>
    </v-btn>
    <amplify-sign-out v-if="user"></amplify-sign-out>
    <v-btn
      v-else
      flat
      outline
      color="orange"
      v-on:click="signIn"
    >
     <span>Sign In</span>
    </v-btn>
  </v-toolbar>
</template>

<script>
import AmplifyStore from '@/store'
import { mapGetters } from 'vuex'

export default {
  name: 'SiteMenu',
  data () {
    return {
      logo: {
        src: 'NoPicHeaderLogo.jpg'
      },
      biker: {
        src: 'biker1.jpg'
      },
      heading: {
        src: 'heading1.jpg'
      }
    }
  },
  computed: {
    user () {
      return AmplifyStore.state.user.user
    },
    ...mapGetters([
      'isAdmin'
    ]),
    addBackground () {
      return this.$route.meta.requiresAuth || false
    }
  },
  methods: {
    home: function () {
      this.$router.push('/')
    },
    register: function () {
      this.$router.push('/register')
    },
    account: function () {
      this.$router.push('/account')
    },
    dashboard: function () {
      this.$router.push('/admin')
    },
    signIn: function () {
      this.$router.push('/auth?redirect=%2Faccount')
    },
    signOut: function () {
      this.$router.push('/auth/signOut')
    }
  }
}
</script>
<style>
  .Button__button___1FrBC {
    padding: 0 16px!important;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    border-radius: 2px;
    display: -webkit-inline-box;
    display: -ms-inline-flexbox;
    display: inline-flex;
    height: 36px;
    -webkit-box-flex: 0;
    -ms-flex: 0 0 auto;
    flex: 0 0 auto;
    font-size: 14px;
    background-color: orange;
    border: solid 1px orange;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    margin: 13px 0 0;
    min-width: 88px!important;
    outline: 0;
    text-transform: uppercase;
    text-decoration: none;
    -webkit-transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1), color 1ms;
    transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1), color 1ms;
    position: relative;
    vertical-align: middle;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
  }

  #headerTitle {
    width: auto;
  }

  #headerTitle img {
    background-size: contain;
    width: 100%;
  }

  @media (max-width: 600px) {
    #headerTitle {
      width: 140px;
    }
  }
</style>
